import React from 'react';
import styled from 'styled-components';
import Digit from './Digit';
import { useTranslation } from 'react-i18next';

const TimerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const SepartorContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-end;
  margin: 0 0 3px 0px;
`;

const Separtor = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #404549;
  border-radius: 6px;
  margin: 5px 0px;
`;

export default function TimerStyled({ seconds, minutes, hours, days, style = {} }) {
  const { t } = useTranslation()

  return (
    <TimerContainer style={{ ...style }}>
      {days !== undefined ? <Digit value={days} title={t('Days')} /> : null}
      {days !== undefined ? (<SepartorContainer><Separtor /><Separtor /></SepartorContainer>) : null}
      <Digit value={hours} title={t('Hours')} />
      <SepartorContainer><Separtor /><Separtor /></SepartorContainer>
      <Digit value={minutes} title={t('Minutes')} />
      <SepartorContainer><Separtor /><Separtor /></SepartorContainer>
      <Digit value={seconds} title={t('Seconds')} />
    </TimerContainer>
  );
}